import { render, staticRenderFns } from "./InputToggle.vue?vue&type=template&id=28f4b2eb&"
import script from "./InputToggle.vue?vue&type=script&lang=js&"
export * from "./InputToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports